import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import logger from '@/sc_utils/logger';
import './WechatShareGuide.scss';

// TODO: pending for implementation
class WechatShareGuide extends PureComponent {
  render() {
	const { options = {} } = this.props;
	const layerClass = ['float-layer'];
	let content = options.wx || '';
	if (options.mp) {
	  layerClass.push('mini-program-layer');
	  if (options.mp !== true) content = options.mp;
	}
	if (content) layerClass.push('content-layer');
    return (
      <div className="wechat-share-guide" role="button" aria-label="取消" onClick={this.props.onCancel}>
	  	{content ? (
          <div
			className={layerClass.join(' ')} dangerouslySetInnerHTML={{__html: content.join('<br />')}}>
          </div>
		) : (
		  <div className={layerClass.join(' ')}></div>
		)}
      </div>
    );
  }
}


WechatShareGuide.show = (options) => {
  logger.debug(`[WechatShareGuide] show`);
  let containerElement = document.createElement("div");
  containerElement.id = "wechat-guide-container";
  document.body.appendChild(containerElement);
  // logger.debug(`[WechatShareGuide] TODO: 微信环境点击分享，需要弹浮层提示用户点右上角分享`);
  // alert(`[WechatShareGuide] TODO: 微信环境点击分享，需要弹浮层提示用户点右上角分享`);
  ReactDOM.render(
    <WechatShareGuide options={options} onCancel={() => {
      if (containerElement) {
        ReactDOM.unmountComponentAtNode(containerElement);
        document.body.removeChild(containerElement);
      }
    }} />,
    containerElement
  );
}


export default WechatShareGuide;
